export default __webpack_public_path__ + "static/media/personaje-Banner-04.f2f09170.png";